var _path, _path2, _path3, _circle, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailMarketingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 43,
    viewBox: "0 0 42 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.6029 35.4195L23.6139 35.4266L23.6253 35.4332L35.8818 42.5H3.75C2.36929 42.5 1.25 41.3807 1.25 40V21.8406C1.25 21.4441 1.68944 21.2053 2.0221 21.4211L23.6029 35.4195Z",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8971 35.4195L17.8861 35.4266L17.8747 35.4332L5.61819 42.5H37.75C39.1307 42.5 40.25 41.3807 40.25 40V21.8406C40.25 21.4441 39.8106 21.2053 39.4779 21.4211L17.8971 35.4195Z",
    stroke: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.25 22L22.2467 1.68858C21.4509 0.790731 20.0491 0.790732 19.2533 1.68858L1.25 22",
    stroke: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.75,
    cy: 14,
    r: 2.5,
    stroke: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.75 23C26.75 20.2386 24.0637 18 20.75 18C17.4363 18 14.75 20.2386 14.75 23",
    stroke: "white",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.75 23C25.2017 23.7455 23.1572 24 20.9159 24C18.5105 24 16.3319 23.9079 14.75 23",
    stroke: "white",
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5082 18.4308C29.6288 14.3305 26.9329 10.5333 22.7983 9.42541C18.6735 8.32017 14.4505 10.2489 12.4986 13.8436",
    stroke: "white",
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9894 23.7723C26.0375 27.367 21.8145 29.2957 17.6897 28.1905C13.6095 27.0972 10.9304 23.3849 10.9765 19.3469",
    stroke: "white",
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.02643 20.9826L10.827 18.4296L13.1489 20.9133",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1316 16.3054L29.7243 18.8944L27.4859 17.3477",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailMarketingIcon);
export default __webpack_public_path__ + "static/media/emailMarketingIcon.013b46897d96278a02e65197ea52f3fa.svg";
export { ForwardRef as ReactComponent };